import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-generic-error-modal',
    templateUrl: './generic-error-modal.component.html',
    styleUrls: ['./generic-error-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericErrorModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<GenericErrorModalComponent>,
    public sanitizer: DomSanitizer,
  ) { }

  public body: string = "";  
  ngOnInit(): void {
    this.body = this.data.body;
  }
  
  close(){
    this.matDialogRef.close(); 
  }
}